import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { AnimatePresence, motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';

const { FiArrowRight, FiGift, FiX } = FiIcons;
const DISMISS_KEY = 'onefinallegacy-launch-offer-dismissed-v1';

function readDismissed() {
  try {
    return window.localStorage.getItem(DISMISS_KEY) === '1';
  } catch {
    return false;
  }
}

const LaunchOfferBanner = () => {
  const [dismissed, setDismissed] = useState(readDismissed);

  const dismiss = () => {
    try {
      window.localStorage.setItem(DISMISS_KEY, '1');
    } catch {
      // Keep dismissal available for this visit if storage is unavailable.
    }
    setDismissed(true);
  };

  return (
    <AnimatePresence>
      {!dismissed && (
        <motion.aside
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 24 }}
          transition={{ duration: 0.25 }}
          className="fixed inset-x-0 bottom-0 z-[90] px-3 pb-3 sm:px-5 sm:pb-5"
          aria-label="Launch offer announcement"
          role="region"
        >
          <div className="mx-auto flex max-w-5xl items-center gap-3 rounded-2xl border border-white/15 bg-accent-navy px-4 py-3 text-white shadow-2xl sm:gap-5 sm:px-6 sm:py-4">
            <span className="hidden h-11 w-11 flex-shrink-0 items-center justify-center rounded-xl bg-accent-gold/15 text-accent-gold sm:flex">
              <SafeIcon icon={FiGift} className="h-5 w-5" />
            </span>

            <div className="min-w-0 flex-1">
              <p className="text-[10px] font-black uppercase tracking-[0.18em] text-accent-gold">
                Launch offer
              </p>
              <p className="mt-0.5 text-sm font-semibold leading-snug sm:text-base">
                Celebrate a life. Preserve a legacy.
              </p>
              <p className="mt-0.5 hidden text-xs leading-relaxed text-white/70 sm:block">
                Explore our launch offer and discover thoughtful ways to honor the people who matter most.
              </p>
            </div>

            <Link
              to="/marketplace"
              className="inline-flex flex-shrink-0 items-center gap-2 rounded-xl bg-accent-gold px-3 py-2.5 text-[10px] font-black uppercase tracking-wider text-accent-navy transition-colors hover:bg-white sm:px-4 sm:text-xs"
            >
              <span>Explore offer</span>
              <SafeIcon icon={FiArrowRight} className="h-4 w-4" />
            </Link>

            <button
              type="button"
              onClick={dismiss}
              aria-label="Dismiss launch offer"
              className="flex-shrink-0 rounded-lg p-2 text-white/65 transition-colors hover:bg-white/10 hover:text-white focus:outline-none focus:ring-2 focus:ring-white/60"
            >
              <SafeIcon icon={FiX} className="h-4 w-4" />
            </button>
          </div>
        </motion.aside>
      )}
    </AnimatePresence>
  );
};

export default LaunchOfferBanner;